// SidebarGuides.js
import guidesConfig from "../../config/guidesConfig.js";

const groupedGuides = Object.values(guidesConfig).reduce((acc, guide) => {
  if (guide.sidebar) {
    const { category, icon, label, sub } = guide.sidebar;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push({
      icon,
      label,
      sub,
      link: guide.route,
      display: guide?.display?.sidebar
    });
  }
  return acc;
}, {});

export const sidebarGuideCategories = Object.entries(groupedGuides).map(
  ([title, items]) => ({
    title,
    items,
  })
);

export default sidebarGuideCategories;
